import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';

type Size = 'mobile' | 'desktop';

const config = {
  mobile: ['(max-width: 767px)'],
  desktop: ['(min-width: 768px)'],
};

@Directive({
  selector: '[viewportSize]',
})
export class ViewportSizeDirective implements OnDestroy {
  private subscription = new Subscription();

  @Input('viewportSize') set size(value: Size) {
    this.subscription.unsubscribe();
    this.subscription = this.breakpointObserver.observe(config[value]).subscribe(this.updateView);
  }

  constructor(
    private breakpointObserver: BreakpointObserver,
    private vcRef: ViewContainerRef,
    private templateRef: TemplateRef<any>
  ) {}

  updateView = ({ matches }: BreakpointState) => {
    if (matches && !this.vcRef.length) {
      this.vcRef.createEmbeddedView(this.templateRef);
    } else if (!matches && this.vcRef.length) {
      this.vcRef.clear();
    }
  };

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
